import { useEffect, useState } from 'preact/hooks'
import { Divider, Typography } from 'antd'
import FadeIn from 'react-fade-in'
import { uid } from '../../helpers/uid.mjs'

const { Title, Paragraph } = Typography

const getBrowserLanguage = () => {
  if (typeof navigator === 'undefined') return 'ru'

  let language = navigator.language || navigator.userLanguage
  language = language.split('-')[0]

  return language
}

const browserLanguage = getBrowserLanguage()

const supportedLanguages = ['ru', 'en', 'sr', 'ua']

const i18n = {
  ru: {
    title: 'Привет! Это @SerbiaRentBot',
    howTitle: 'Наш бот предназначен для поиска жилья в Сербии в самые короткие сроки. И вот как мы это делаем:',
    how1: 'Вы расскажете нам, что именно вы ищете;',
    how2: 'Мы покажем вам подходящие варианты;',
    how3: 'После этого будем держать вкурсе обо всех подходящих для вас объявлениях.',
    whyTitle: 'Чем мы лучше других?',
    why1: 'С нами можно искать жильё по всей территории Сербии, а не только в Белграде и Нови-Саде;',
    why2: 'Мы собираем объявления с самых крупных площадок и отсеиваем дубли;',
    why3: 'Мы сообщаем об изменении цены;',
    why4: 'Мы поддерживаем 3 языка: 🇷🇺, 🇬🇧 и 🇷🇸.',
    info: 'Услуга бесплатная, но есть и платная подписка (990₽ или €15), чтобы искать было ещё удобнее и ещё оперативнее!',
    go: 'Перейти к @SerbiaRentBot',
    terms: 'Пользовтельское соглашение',
    privacy: 'Политика конфиденциальности',
    oferta: 'Публичная оферта',
  },
  en: {
    title: 'Hello! This is @SerbiaRentBot',
    howTitle:
      "Our bot is designed to find accommodation in Serbia in the shortest possible time. And here's how we do it:",
    how1: "You tell us exactly what you're looking for;",
    how2: 'We show you suitable options;',
    how3: 'After that, we keep you informed about all the suitable listings for you.',
    whyTitle: 'Why are we better than others?',
    why1: 'With us, you can search for accommodation across all of Serbia, not just in Belgrade and Novi Sad;',
    why2: 'We collect ads from the largest platforms and filter out duplicates;',
    why3: 'We notify about price changes;',
    why4: 'We support 4 languages: 🇷🇺, 🇺🇦, 🇬🇧 and 🇷🇸.',
    info: 'The service is free, but there is also a paid subscription to make the search even more convenient and even more operational!',
    go: 'Open @SerbiaRentBot',
    terms: 'Terms of Use',
    privacy: 'Privacy Policy',
    oferta: 'Public offer',
  },
  sr: {
    title: 'Zdravo! Ovo je @SerbiaRentBot',
    howTitle: 'Naš bot je dizajniran da pronađe smeštaj u Srbiji u najkraćem mogućem roku. A evo kako to radimo:',
    how1: 'Recite nam tačno šta tražite;',
    how2: 'Prikazujemo vam odgovarajuće opcije;',
    how3: 'Nakon toga vas obaveštavamo o svim odgovarajućim listinzima za vas.',
    whyTitle: 'Zašto smo bolji od drugih?',
    why1: 'S nama možete tražiti smeštaj širom cele Srbije, a ne samo u Beogradu i Novom Sadu;',
    why2: 'Sakupljamo oglase sa najvećih platformi i filtriramo duplikate;',
    why3: 'Obaveštavamo o promenama cena;',
    why4: 'Podržavamo 4 jezika: 🇷🇺, 🇺🇦, 🇬🇧 i 🇷🇸.',
    info: 'Usluga je besplatna, ali postoji i plaćena pretplata da bi pretraga bila još prikladnija i još operativnija!',
    go: 'Otvori @SerbiaRentBot',
    terms: 'Uslovi korišćenja',
    privacy: 'Politika privatnosti',
    oferta: 'Javni ugovor',
  },
  ua: {
    title: 'Привіт! Це @SerbiaRentBot',
    howTitle: 'Наш бот призначений для пошуку житла в Сербії в найкоротші терміни. А ось як ми це робимо:',
    how1: 'Ви розповісте нам, що саме ви шукаєте;',
    how2: 'Ми покажемо вам підходящі варіанти;',
    how3: 'Після цього будемо тримати вас в курсі про всі підходящі для вас оголошення.',
    whyTitle: 'Чому ми кращі за інших?',
    why1: 'З нами можна шукати житло по всій території Сербії, а не лише в Белграді і Новом Саду;',
    why2: 'Ми збираємо оголошення з найбільших площадок і відсіюємо дублікати;',
    why3: 'Ми повідомляємо про зміну ціни;',
    why4: 'Ми підтримуємо 4 мови: 🇷🇺, 🇺🇦, 🇬🇧 та 🇷🇸.',
    info: 'Послуга безкоштовна, але є також платна підписка, щоб пошук був ще зручнішим і ще оперативнішим!',
    go: 'Відкрити @SerbiaRentBot',
    terms: 'Умови використання',
    privacy: 'Політика конфіденційності',
    oferta: 'Публічна оферта',
  },
}

export const HomePage = () => {
  const [language, setLanguage] = useState(supportedLanguages.includes(browserLanguage) ? browserLanguage : 'ru')

  useEffect(() => {
    const extId = localStorage.getItem('extId')
    const anonId = localStorage.getItem('anonId')

    if (!extId && !anonId) {
      const id = uid(9)

      localStorage.setItem('anonId', id)

      analytics.page({
        anonymousId: id,
        //userId: "some_user_id",
        //category: "Merchant",
        //name: "Settings",
      })
    }
  })

  return (
    <div className="block-1">
      <div className="block-2">
        <FadeIn delay={1000} transitionDuration={800}>
          <div className="block-3">
            <FadeIn delay={200} transitionDuration={800} style={{ width: '100%' }}>
              <div style={{ fontSize: 60, lineHeight: '60px', marginBottom: -10 }}>🇷🇸</div>
              <div style={{ position: 'relative' }}>
                <div className="screenshot">
                  <img
                    src={`/assets/screenshot_${language}.webp`}
                    alt=""
                    width={246}
                    style={{ position: 'absolute', left: 14, top: 12, borderRadius: 20 }}
                  />
                  <img src="/assets/image.webp" alt="" width={273} style={{ position: 'absolute' }} />
                </div>
              </div>
              <Title level={3}>{i18n[language].title}</Title>
              <Divider />
              <Paragraph className="p-width">{i18n[language].howTitle}</Paragraph>
              <Paragraph className="p-width">
                <ol>
                  <li>{i18n[language].how1}</li>
                </ol>
              </Paragraph>
              <Paragraph className="p-width _mt">
                <ol start={2}>
                  <li>{i18n[language].how2}</li>
                </ol>
              </Paragraph>
              <Paragraph className="p-width _mt">
                <ol start={3}>
                  <li>{i18n[language].how3}</li>
                </ol>
              </Paragraph>
              <Paragraph>{i18n[language].whyTitle}</Paragraph>
              <Paragraph className="p-width _mt">
                <ul>
                  <li>{i18n[language].why1}</li>
                </ul>
              </Paragraph>
              <Paragraph className="p-width _mt">
                <ul>
                  <li>{i18n[language].why2}</li>
                </ul>
              </Paragraph>
              <Paragraph className="p-width _mt">
                <ul>
                  <li>{i18n[language].why3}</li>
                </ul>
              </Paragraph>
              <Paragraph className="p-width _mt">
                <ul>
                  <li>{i18n[language].why4}</li>
                </ul>
              </Paragraph>
              <Paragraph className="p-width">{i18n[language].info}</Paragraph>
              <Paragraph className="button-wrapper">
                <a
                  href={`https://t.me/SerbiaRentBot?start=landing_${language}`}
                  target="_blank"
                  className="button-main"
                >
                  <svg
                    className="button-main-svg"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    width="24px"
                    height="24px"
                  >
                    <path d="M 26.070313 3.996094 C 25.734375 4.011719 25.417969 4.109375 25.136719 4.21875 L 25.132813 4.21875 C 24.847656 4.332031 23.492188 4.902344 21.433594 5.765625 C 19.375 6.632813 16.703125 7.757813 14.050781 8.875 C 8.753906 11.105469 3.546875 13.300781 3.546875 13.300781 L 3.609375 13.277344 C 3.609375 13.277344 3.25 13.394531 2.875 13.652344 C 2.683594 13.777344 2.472656 13.949219 2.289063 14.21875 C 2.105469 14.488281 1.957031 14.902344 2.011719 15.328125 C 2.101563 16.050781 2.570313 16.484375 2.90625 16.722656 C 3.246094 16.964844 3.570313 17.078125 3.570313 17.078125 L 3.578125 17.078125 L 8.460938 18.722656 C 8.679688 19.425781 9.949219 23.597656 10.253906 24.558594 C 10.433594 25.132813 10.609375 25.492188 10.828125 25.765625 C 10.933594 25.90625 11.058594 26.023438 11.207031 26.117188 C 11.265625 26.152344 11.328125 26.179688 11.390625 26.203125 C 11.410156 26.214844 11.429688 26.21875 11.453125 26.222656 L 11.402344 26.210938 C 11.417969 26.214844 11.429688 26.226563 11.441406 26.230469 C 11.480469 26.242188 11.507813 26.246094 11.558594 26.253906 C 12.332031 26.488281 12.953125 26.007813 12.953125 26.007813 L 12.988281 25.980469 L 15.871094 23.355469 L 20.703125 27.0625 L 20.8125 27.109375 C 21.820313 27.550781 22.839844 27.304688 23.378906 26.871094 C 23.921875 26.433594 24.132813 25.875 24.132813 25.875 L 24.167969 25.785156 L 27.902344 6.65625 C 28.007813 6.183594 28.035156 5.742188 27.917969 5.3125 C 27.800781 4.882813 27.5 4.480469 27.136719 4.265625 C 26.769531 4.046875 26.40625 3.980469 26.070313 3.996094 Z M 25.96875 6.046875 C 25.964844 6.109375 25.976563 6.101563 25.949219 6.222656 L 25.949219 6.234375 L 22.25 25.164063 C 22.234375 25.191406 22.207031 25.25 22.132813 25.308594 C 22.054688 25.371094 21.992188 25.410156 21.667969 25.28125 L 15.757813 20.75 L 12.1875 24.003906 L 12.9375 19.214844 C 12.9375 19.214844 22.195313 10.585938 22.59375 10.214844 C 22.992188 9.84375 22.859375 9.765625 22.859375 9.765625 C 22.886719 9.3125 22.257813 9.632813 22.257813 9.632813 L 10.082031 17.175781 L 10.078125 17.15625 L 4.242188 15.191406 L 4.242188 15.1875 C 4.238281 15.1875 4.230469 15.183594 4.226563 15.183594 C 4.230469 15.183594 4.257813 15.171875 4.257813 15.171875 L 4.289063 15.15625 L 4.320313 15.144531 C 4.320313 15.144531 9.53125 12.949219 14.828125 10.71875 C 17.480469 9.601563 20.152344 8.476563 22.207031 7.609375 C 24.261719 6.746094 25.78125 6.113281 25.867188 6.078125 C 25.949219 6.046875 25.910156 6.046875 25.96875 6.046875 Z" />
                  </svg>

                  {i18n[language].go}
                </a>
              </Paragraph>
            </FadeIn>
          </div>
          <Paragraph
            style={{
              padding: 10,
              textAlign: 'center',
              position: 'relative',
              zIndex: 1,
              marginTop: 10,
              marginBottom: 0,
              fontSize: 20,
            }}
          >
            <a className="lang-link" onClick={() => setLanguage('ru')}>
              🇷🇺
            </a>
            <a className="lang-link" onClick={() => setLanguage('ua')}>
              🇺🇦
            </a>
            <a className="lang-link" onClick={() => setLanguage('en')}>
              🇬🇧
            </a>
            <a className="lang-link" onClick={() => setLanguage('sr')}>
              🇷🇸
            </a>
          </Paragraph>

          <Paragraph
            style={{
              padding: 10,
              textAlign: 'center',
              position: 'relative',
              zIndex: 1,
              marginTop: -5,
              marginBottom: 0,
            }}
          >
            <span
              style={{
                display: 'inline-block',
                color: 'white',
                textAlign: 'center',
                marginRight: 15,
              }}
            >
              {i18n[language].terms}
              <br />
              <a href="/docs/terms_ru.pdf" className="docs-link">
                ru
              </a>
              {' / '}
              <a href="/docs/terms_en.pdf" className="docs-link">
                intl
              </a>
            </span>
            <span
              style={{
                display: 'inline-block',
                color: 'white',
                textAlign: 'center',
              }}
            >
              {i18n[language].oferta}
              <br />
              <a href="/docs/oferta.docx" className="docs-link">
                ru
              </a>
            </span>
            <span
              style={{
                display: 'inline-block',
                color: 'white',
                textAlign: 'center',
                marginLeft: 15,
              }}
            >
              {i18n[language].privacy}
              <br />
              <a href="/docs/privacy_ru.pdf" className="docs-link">
                ru
              </a>
              {' / '}
              <a href="/docs/privacy_en.pdf" className="docs-link">
                intl
              </a>
            </span>
          </Paragraph>
        </FadeIn>
      </div>
    </div>
  )
}
